export default __webpack_public_path__ + "static/media/logo.df766bc6.svg";